import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 导入模板样例查询
export function getOrderTemplateSample(params) {
  return request({
    url: URL.sys.getOrderTemplateSample,
    method: 'get',
    params
  })
}

// 导入模板样例删除
export function deleteOrderTemplateSample(params) {
  return request({
    url: URL.sys.deleteOrderTemplateSample,
    method: 'delete',
    params
  })
}
